// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"20":"a7b32b6e47e9f284","523":"215c77b1c2a12b43","580":"b2d02feb1b03b455"}[chunkId] + ".js";
};